licenseTable.$inject = ['filterFilter', 'orderByFilter']

export default function licenseTable(filterFilter, orderByFilter) {
  return {
    restrict: 'EA',
    scope: {
      licenses: '='
    },
    link: function(scope, elm, attrs) {
      scope.search = ''
      scope.orderKey = ''
      scope.reverse = false
      scope.showSearch = scope.$eval(attrs.showSearch)

      scope.sort = function(key) {
        if (scope.orderKey === key) {
          scope.reverse = !scope.reverse
        } else {
          scope.reverse = false
        }
        scope.orderKey = key
      }

      scope.$watchCollection('licenses', function() {
        refreshResults()
      })
      scope.$watch('search', function(search) {
        refreshResults()
      })
      scope.$watch('orderKey', function(key) {
        refreshResults()
      })
      scope.$watch('reverse', function(rev) {
        refreshResults()
      })

      function refreshResults() {
        scope.filteredLicenses = filterFilter(scope.licenses, scope.search)
        scope.filteredLicenses = orderByFilter(
          scope.filteredLicenses,
          scope.orderKey,
          scope.reverse
        )
      }
    },
    template: require('./_licenseTable.html')
  }
}
